import { SVGProps } from 'react';

const DaswatchSvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    viewBox="10 0 32 32"
    fill="none"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M20.7543 7C20.3078 7 19.9154 7.29598 19.7928 7.72528L18.443 12.4496C20.1985 10.9237 22.4914 10 25 10C27.5086 10 29.8015 10.9237 31.557 12.4496L30.2072 7.72528C30.0846 7.29598 29.6922 7 29.2457 7H20.7543ZM19.7928 32.2747L18.443 27.5504C20.1985 29.0763 22.4914 30 25 30C27.5086 30 29.8015 29.0763 31.557 27.5504L30.2072 32.2747C30.0846 32.704 29.6922 33 29.2457 33H20.7543C20.3078 33 19.9154 32.704 19.7928 32.2747ZM25 26C28.3137 26 31 23.3137 31 20C31 16.6863 28.3137 14 25 14C21.6863 14 19 16.6863 19 20C19 23.3137 21.6863 26 25 26ZM25 28C29.4183 28 33 24.4183 33 20C33 15.5817 29.4183 12 25 12C20.5817 12 17 15.5817 17 20C17 24.4183 20.5817 28 25 28ZM26 19.5858V16H24V20V20.4142L24.2929 20.7071L26.2929 22.7071L27.7071 21.2929L26 19.5858Z"
    />
  </svg>
);
export default DaswatchSvgIcon;
